<template>
  <BreadCrumb PageTitle="Liste des Catégories" />
  <ListeCategorieDocument />
</template>
  
<script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeCategorieDocument from "../../components/CategorieDocument/ListeCategorie.vue";
  
  export default defineComponent({
    name: "ListeCategorieDocumentPage",
    components: {
      BreadCrumb,
      ListeCategorieDocument,
    },
  });
</script>